export default "__VITE_ASSET__71cba549__"